import React, { Component } from 'react';

import { Modal } from 'react-bootstrap';
import ScheduledEvents from './ScheduledEvents';
import InfoTooltipIcon from '../../assets/InfoTooltipIcon';

export default class DisplayRowString extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <tr>
        <td className="labelColumn">
          {this.props.prettyName}
          {this.props.tooltip ? (
            <InfoTooltipIcon tooltipText={this.props.tooltip} />
          ) : (
            ''
          )}
        </td>
        <td className="detailColumn" onClick={this.props.handleOpen}>
          {this.props.value}
        </td>
        {this.props.edit && (
          <Modal show={this.props.edit}>
            <Modal.Header>
              <Modal.Title>{this.props.prettyName}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <input
                type="text"
                value={this.props.value}
                name={this.props.id}
                id={this.props.id}
                onChange={this.props.handleChange}
                className="form-control"
              />
              <font className="mandatory">{this.props.errorString}</font>

              <ScheduledEvents
                events={this.props.events}
                id={this.props.id}
                deleteScheduleAction={this.props.deleteScheduleAction}
              />
            </Modal.Body>
            <Modal.Footer>
              &nbsp;
              <button
                onClick={this.props.handleClose}
                type="button"
                className="btn modalButtons btn-primary"
              >
                Close
              </button>
              {this.props.handleGenerate && (
                <button
                  onClick={this.props.handleGenerate}
                  type="button"
                  className="btn modalButtons btn-info"
                >
                  Get aprivaDeviceAddress
                </button>
              )}
              <button
                onClick={this.props.handleSave}
                type="button"
                className="btn modalButtons btn-success"
              >
                Save
              </button>
              <button
                onClick={this.props.handleSchedule}
                type="button"
                className="btn modalButtons btn-success"
              >
                Schedule
              </button>
            </Modal.Footer>
          </Modal>
        )}
      </tr>
    );
  }
}
